import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawVdsHor1Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "vds-hor-1";
		this.icon = svg_vds_hor_1;
	}
}

window.customElements.define("inspx-draw-vds-hor-1-module", DrawVdsHor1Module);

const svg_vds_hor_1 = html`
<svg width="90" height="30" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
    <g>
        <title>Layer 1</title>
        <rect id="svg_2" height="30" width="90" y="0" x="0" stroke="#444444" fill="#ffffff" />
        <line stroke="#444444" id="svg_1" y2="0" x2="30" y1="30" x1="30" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null"
            fill="none" />
        <line id="svg_3" stroke="#444444" y2="0" x2="60" y1="30" x1="60" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null"
            fill="none" />
        <text stroke="#444444" transform="matrix(1.748146119803863,0,0,1,-3.435311616745808,0) " xml:space="preserve" text-anchor="middle"
            font-family="Sans-serif" font-size="24" id="svg_4" y="23.52072" x="27.304868" stroke-linecap="null" stroke-linejoin="null"
            stroke-dasharray="null" stroke-width="0" fill="#000000">VDS</text>
        <line id="svg_5" stroke="#444444" transform="rotate(-90.42057800292969 60.16937255859375,15.401206970214847) " y2="15.40121"
            x2="75.16937" y1="15.40121" x1="45.16937" fill="none" />
    </g>
</svg>`;
